import { combineReducers } from 'redux'
import { reducer as disabledCadres } from './getDisabledCadres'
import { reducer as allCadres } from './getAllCadres'
import { reducer as addCadre } from './addCadre'
import { reducer as editCadre } from './editCadre'
import { reducer as deleteCadre } from './deleteCadre'

export default combineReducers({
    allCadres,
    disabledCadres,
    editCadre,
    deleteCadre,
    addCadre,
})
